











































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import data from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/FormErrorMessages";
import { IAddressVueModel } from '@/ts/models/IAddressVueModel';

@Component({
    props: {
        form: {
            type: Object as () => IAddressVueModel
        },
        addressType: {
            type: String 
        },
        isReadOnly: {
            type: Boolean
        },
        hideCountry: {
          type: Boolean
        }
    }
})
export default class AddressInfo extends Vue {

    name: string = "address-info";

    states: any = [];
    cities: any = [];
    countries: any = [];
    streetTypes: any = [];
    streetDirections: any = [];
    errorMsgs = ErrorMessages;

    addressId: string = "";

    created(): void {
        this.cities = data.cities;
        this.states = data.states;
        this.streetTypes = data.streetTypes;
        this.streetDirections = data.streetDirections;
        this.countries = data.countries;
        if (this.$props.form.country == null) {
            this.$props.form.country = "United States of America";
        }
    }

    mounted(): void {
        if (func.isNullOrEmpty(this.$props.form.id)) {
            this.$props.form.id = data.getNewId();
            this.addressId = this.$props.form.id;
        }
        if (func.isNullOrEmpty(this.$props.form.state)) {
            this.$props.form.state = "IL";
        }

        this.$props.form.addressType = this.$props.addressType;

        this.$watch("hasErrors", (n, o) => {
            this.$emit("update:hasAddressError", this.hasErrors);
        }, { immediate: !this.$props.isReadOnly });

        this.$watch("form.country", (n, o) => {
            if (this.$props.form.country != "United States of America") {
                this.$props.form.state = "";
            }
        });
    }

    get isStreetNumberError(): boolean {
        if (this.$props.form.streetNumber) {
            return this.$props.form.streetNumber.length > 10;
        }
        return func.isNullOrEmpty(this.$props.form.streetNumber);
    }

    /*
    get isStreetDirectionError(): boolean {
        return func.isNullOrEmpty(this.$props.form.streetDirection);
    }
    */
    get isStreetNameError(): boolean {
        if (this.$props.form.streetName) {
            return this.$props.form.streetName.length > 75;
        }
        return func.isNullOrEmpty(this.$props.form.streetName);
    }

    get isStreetTypeError(): boolean {
        return func.isNullOrEmpty(this.$props.form.streetType);
    }

    get isCityError(): boolean {
        return func.isNullOrEmpty(this.$props.form.city) || this.$props.form.city.length > 50;
    }

    get isStateError(): boolean {
        if (this.$props.form.country == "United States of America" || this.$props.hideCountry) {
            return func.isNullOrEmpty(this.$props.form.state);
        } else {
            return !func.isNullOrEmpty(this.$props.form.state);
        }
    }

    get isZipError(): boolean {
        if (this.$props.form.zip) {
            return this.$props.form.zip.length > 15;
        }
        return func.isNullOrEmpty(this.$props.form.zip);
    }

    get isCountryError(): boolean {
        return func.isNullOrEmpty(this.$props.form.country);
    }

    get hasErrors(): boolean {
        return this.isStreetNumberError || this.isStreetNameError || this.isStreetTypeError || this.isCityError || this.isStateError || this.isZipError || this.isCountryError;
    }
}
